import { useState } from "react";

import { useLanguage } from "context/LanguageContext";
import ChangeLanguage from "components/ChangeLanguage";

import { NotificationProvider } from "context/NotificationContext";

import Entra from "./modules/Entra";
import Cadastro from "./modules/Cadastro";

import "./styleds.scss";
import FormTrocaSenha from "./modules/FormTrocaSenha";

import logo from "assets/img/cardux_login.png";

const Login = () => {
  const { GetTranslation } = useLanguage();
  const [isLogin, setisLogin] = useState(true);
  const [IsRecuperaSenha, setIsRecuperaSenha] = useState(false);

  const [EtapaTrocarSenha, setEtapaTrocarSenha] = useState(0);

  return (
    <div className="login">
      <img src={logo} alt="Logo da Empresa" className="logo-top-right" />
      <div className="c-1" />
      <div className="c-2" />
      <NotificationProvider>
        <div className="card p-3 d-flex flex-column gap-3">
          {isLogin ? (
            <>
              <h1 className="fs-3">{GetTranslation("welcome")}</h1>
              <p className="m-0">{GetTranslation("welcome_p2")}</p>
              <Entra />
              <div className="d-flex justify-content-center gap-3">
                <button
                  type="button"
                  className="btn"
                  onClick={() => {
                    setisLogin(false); 
                    setIsRecuperaSenha(false);
                  }}
                >
                  {GetTranslation("Register")}
                </button>
                <button
                  type="button"
                  className="btn"
                  onClick={() => {
                    setisLogin(false);
                    setIsRecuperaSenha(true);
                  }}
                >
                  {GetTranslation("esqueceu_sua_senha")}
                </button>
              </div>
              <div className="mt-3">
                <ChangeLanguage />
              </div>
            </>
          ) : IsRecuperaSenha ? (
            <FormTrocaSenha
              EtapaTrocarSenha={EtapaTrocarSenha}
              setEtapaTrocarSenha={setEtapaTrocarSenha}
              ShowLogin={() => {
                setEtapaTrocarSenha(0);
                setisLogin(true);
              }}
            />
          ) : (
            <>
              <Cadastro setisLogin={setisLogin}/>
              <div className="d-flex justify-content-center-3">
                <button
                  type="button"
                  className="btn"
                  onClick={() => setisLogin(true)}
                >
                  {GetTranslation("Already_Registered")}
                </button>
              </div>
              <ChangeLanguage />
            </>
          )}
        </div>
      </NotificationProvider>
    </div>
  );
};

export default Login;
